export function getDashboardPathForRole(role: string): string {
  const normalized = (role || "").toLowerCase();

  if (normalized === "proctor") {
    return "/proctor/dashboard";
  }
  if (normalized === "principal" || normalized === "subject area coordinator") {
    return "/admin/dashboard";
  }
  return "/student/dashboard";
}
